var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#icon-site';
                    var viewUrl = 'sprite.svg#view-icon-site';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 3425 3623',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };